import { render, staticRenderFns } from "./PaymentOptions.vue?vue&type=template&id=c636f8d2&"
import script from "./PaymentOptions.vue?vue&type=script&setup=true&lang=js&"
export * from "./PaymentOptions.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports